module.exports = __webpack_public_path__ + "img/296.d305bd87.jpg";